import { useContext, useEffect, useState } from "react";
import styles from "./screenInstructions.module.scss";
import CurrentContext from "../utils/CurrentContext";
import Button from "./button";

export default function Instructions() {
  const { answers, setCurrentScreen } = useContext(CurrentContext);

  function HandleClick() {
    setCurrentScreen("game");
  }

  return (
    <div className={styles.instruction_wrapper}>
      <div className={styles.instructionBtnWrapper} onClick={HandleClick}>
        <img
          className={styles.instruction}
          src="instructions.jpg"
          alt="instructions"
          onClick={HandleClick}
        />
      </div>
    </div>
  );
}
